import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

export const GET_BRANDS = 'api/brand/get-brands';

export const getBrandsQueryKey = ['brands'];

export type Brand = {
  BrandId: number;
  BrandName: string;
  IsDeleted: boolean;
  LspId: number;
};

export function useBrandsQuery() {
  return useQuery({
    queryKey: getBrandsQueryKey,
    queryFn: () => fetchData<Brand[]>(GET_BRANDS),
  });
}
